<div class="container" *ngIf="!isLoading">
    <div class="back-button" (click)="backButtonClick()">
        {{
            'system-specifications.back'
                | translate
                    : {
                          vesselName: vessel?.name,
                          vesselNumber: vessel?.number,
                      }
        }}
    </div>

    <div class="title-container">
        <div class="title">{{ 'system-specifications.title' | translate }}</div>
        <div class="page-button" (click)="goToDeviceList()">
            <div>
                {{ 'system-specifications.button-device-list' | translate }}
            </div>
            <mat-icon svgIcon="arrow-right" class="icon" />
        </div>
    </div>

    <div class="tabs-container" #tabsContainer>
        <div class="tab-wrapper" [class.selectedTab]="isTabSelected(HARDWARE_TAB)" (click)="selectTab(HARDWARE_TAB)">
            {{ 'system-specifications.tab.hardware' | translate }}
        </div>
        <div class="tab-wrapper" [class.selectedTab]="isTabSelected(SOFTWARE_TAB)" (click)="selectTab(SOFTWARE_TAB)">
            {{ 'system-specifications.tab.software' | translate }}
        </div>
        <div class="tab-wrapper" [class.selectedTab]="isTabSelected(OTHERS_TAB)" (click)="selectTab(OTHERS_TAB)">
            {{ 'system-specifications.tab.others' | translate }}
        </div>
    </div>

    <ng-container *ngIf="userCanEdit && !isTabSelected(SOFTWARE_TAB)">
        <div class="button-wrap">
            <button (click)="cancel()" class="white">
                {{ 'graph.exhaust.table.button.cancel' | translate }}
            </button>
            <button class="save" (click)="save()" [disabled]="!isSaveEnabled">
                {{ 'graph.exhaust.table.button.save' | translate }}
            </button>
        </div>
    </ng-container>

    <div>
        <ng-container *ngIf="isTabSelected(HARDWARE_TAB)">
            <app-hardware-specifications
                #hardwareSettings
                [hardwareSpecification]="hardwareSpecification"
                [userCanEdit]="userCanEdit"></app-hardware-specifications>
        </ng-container>

        <ng-container *ngIf="isTabSelected(SOFTWARE_TAB)">
            <app-software-specifications
                #softwareSettings
                [softwareSpecification]="softwareSpecification"></app-software-specifications>
        </ng-container>

        <ng-container *ngIf="isTabSelected(OTHERS_TAB)">
            <app-other-specifications
                #otherSettings
                [othersSpecification]="othersSpecification"
                [userCanEdit]="userCanEdit"></app-other-specifications>
        </ng-container>
    </div>
</div>

<ng-container *ngIf="isScrollBtnVisible">
    <app-to-top (onTopEmit)="handleGoToTop()"></app-to-top>
</ng-container>

<ng-container *ngIf="isLoading"> <app-loading-spinner class="spinner-loading"></app-loading-spinner></ng-container>
